import React from 'react';

import { Tooltip } from 'components';
import { useBreakpoint } from 'hooks';
import { MAX_TOUR_STOPS } from './constants';

type MaxItemsExceededTooltipProps = {
  children: React.ReactChild;
  totalStops: number;
};

const MaxItemsExceededTooltip: React.FC<MaxItemsExceededTooltipProps> = ({
  children,
  totalStops,
}) => {
  // as per figma, display tooltip text all on one line until screen size is prohibitive of this behaviour.
  const { md } = useBreakpoint();

  return (
    <Tooltip
      overlayStyle={{ ...(md && { maxWidth: 'fit-content' }) }}
      title={
        totalStops >= MAX_TOUR_STOPS &&
        `A tour cannot exceed ${MAX_TOUR_STOPS} stops. Please create a new tour to add more stops.`
      }
      trigger={md ? 'hover' : 'click'}
    >
      {children}
    </Tooltip>
  );
};

export default MaxItemsExceededTooltip;
